import React from 'react'
import { css } from 'aphrodite'
import styles from './styles'
import { Dropdown } from '@billes/components'
import { connect } from '@cerebral/react'
import { signal, state } from 'cerebral/tags'
import { History, Administration, Exit } from 'components/Icons'
import UserSection from './userSection'
import SystemSection from './systemSection'
import SystemTab from './systemTab'
import { t } from '@billes/translator-client'
import isAdmin from 'utils/isAdmin'
import { Action } from '@billes/components'
import checkHaikom from 'utils/checkHaikom'

const Header = connect(
  {
    onLogoClicked: signal`app.onLogoClicked`,
    group: state`app.user.group`,
    loadForAllUsersOrderHistory: signal`orderHistory.loadForAllUsersOrderHistory`,
    logo: state`app.client.logo`,
    haikomUrl: state`app.client.haikomUrl`
  },
  ({ onLogoClicked, group, loadForAllUsersOrderHistory, logo, haikomUrl }) => {
    const isHaikom = checkHaikom()
    return (
      <div className={css(styles.header)}>
        <div className={css(styles.headerInner)}>
          <div className={css(styles.logoContainer)}>
            <div onClick={e => onLogoClicked()} className={css(styles.logo)}>
              <img src={logo} alt={''} style={{ maxWidth: 350 }} />
            </div>
          </div>
          <SystemTab />
          <div className={css(styles.headerRole)}>
            <div className={css(styles.iconContainer)}>
              {isAdmin(group) ? (
                <div style={{ display: 'inline-block' }}>
                  <Dropdown
                    icon={<Administration />}
                    label={t('bms.header.administration')}
                    items={[
                      {
                        icon: <History />,
                        label: t('bms.header.orderHistory'),
                        action: () => loadForAllUsersOrderHistory()
                      }
                    ]}
                  />
                </div>
              ) : null}

              {isHaikom ? (
                <Action
                  icon={<Exit />}
                  label={t('common.back')}
                  link={haikomUrl}
                />
              ) : (
                <SystemSection />
              )}
              <UserSection />
            </div>
          </div>
        </div>
      </div>
    )
  }
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/header.js